export interface ITextCopyable {
  textToCopy: string;
}

export function instanceOfITextCopyable(instance: any): instance is ITextCopyable {
  return instance
    && (instance.textToCopy !== undefined);
}
